
export default function App(props) {
  var allStyles = props.styles;
  var onClick= props.onClick;
  var actHoveringWhere = props.actHoveringWhere;
  var itemPath = props.itemPath;

  var onClick1 = function(e){
    if (onClick){
      onClick(e);
    }
  }

  var txt1 = allStyles.text;
  if (allStyles.B){
    txt1 = <b>{txt1}</b>
  }
//
  if (allStyles.U){
    txt1 = <u>{txt1}</u>
  }
//            
  if (allStyles.I){
    txt1 = <i>{txt1}</i>
  }
//  
  return <span onClick={onClick1} style={allStyles} onMouseOver={actHoveringWhere(itemPath.join(' '))} onMouseOut={actHoveringWhere('')}>{txt1}</span>
}